import { capitalizeAll } from '@btime/helpers'
import { compose, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../../../components/presentation/Text'
import Panel from '../../../../../components/structure/Panel'
import PlaceSelect from '../../../../../containers/places/select/PlaceSelect'
import {
  useExecutionDynamicServiceOrders,
  useExecutionDynamicServiceOrdersActions
} from '../../_form/ExecutionDynamicServiceOrdersHandler'
import { useDynamicServiceOrders } from '../../_load/DynamicServiceOrdersLoader'
import Modal from '../../../../../components/structure/Modal'
import { COLORS } from '@btime/constants'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import Line from '../../../../../packages/kiti/components/helpers/Line'
import LocksContent from '../../../../places/show/tabs/locks/Locks'
import { clearFilterParams } from '../../../editV2/_helpers/filters'

const DynamicServiceOrdersPlaceDetailsPanel = () => {
  const { t } = useTranslation(['common', 'listDynamicServiceOrders'])
  const { place, configuration, checklistId } = useDynamicServiceOrders()
  const type = compose(capitalizeAll, prop('type'))(place)
  const { setForm } = useExecutionDynamicServiceOrdersActions()
  const executionForm = useExecutionDynamicServiceOrders()
  const [open, setOpen] = React.useState()
  const [selectedPlace, setSelectedPlace] = React.useState()

  const placeFilters = clearFilterParams({
    types: configuration?.placeTypes,
    placeLevelIds: configuration?.placeLevels
  })

  const handleChange = value => {
    setForm({ ...executionForm, place: value })
  }

  const reasonForDisablePresenter = place => {
    setOpen(true)
    setSelectedPlace(place)
  }

  return (
    <Panel lineBorder mediumPadding>
      <Title size="h6">{t('place', { context: type })}</Title>
      <PlaceSelect
        filter={{ ...placeFilters, lock: { checklistId } }}
        placeholder={t('listDynamicServiceOrders:selectPlace')}
        disabled={!!place}
        onChange={handleChange}
        value={executionForm?.place}
        reasonForDisablePresenter={reasonForDisablePresenter}
      />
      <Modal open={open && selectedPlace} onClose={() => setOpen(false)} width="46rem">
        <Title size="h3" strong color={COLORS.dark2} noMargin>
          {t('listDynamicServiceOrders:lockReasons')}
        </Title>
        {selectedPlace && <Text>{selectedPlace.name}</Text>}
        <Separator weight={2} />
        <Line />
        <Separator weight={2} />
        <LocksContent checklistId={checklistId} placeId={selectedPlace?.id} />
      </Modal>
    </Panel>
  )
}

export default DynamicServiceOrdersPlaceDetailsPanel
